    <div class="control-point-page">
      <!-- Map principale pour Control Points -->
      <app-map 
        class="map-container">
      </app-map>
    </div>